

<template>
    <div class="aboutWarp" v-if="isMobile != 0">
      <div class="web" v-if="isMobile == 1">
        <header-view ref="headers"></header-view>
        <div class="page page2 page-2" :style="'padding-bottom:'+footerHeight+'px;padding-top:'+headerHeight+'px'">
          <div class="page2Warp">
            <div class="twoPageWarp">
              <div class="page2TitleWarp">
                <div class="title fAb flexSw">
                  <div>About Us</div>
                  <PcBak :home-index="1"></PcBak>
                </div>
                <div class="desc fOM" v-html="aboutInfo.one.desc">
                </div>
              </div>
              <div class="artList">
                <div class="artItem" v-for="v in aboutInfo.two">
                  <img class="artItemImage" src="../../assets/image/art_list_log.png" alt="">
                  <div class="artItemText fOR" v-html="v.desc">

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="mobileAbout pw100" v-else>
        <aboutView :aList="aList"></aboutView>
      </div>
    </div>
</template>
<script>

import headerView from "@/components/Common/Header.vue";
import PcBak from "@/components/Common/pcBak.vue";
import aboutView from "@/components/Mobile/about.vue"

export default {
  components: {headerView,aboutView,PcBak},
  data(){
    return {
      headerHeight: 104,
      footerHeight: 20,
    }
  },
  computed:{
    isMobile(){
      return this.$store.getters.isMobile;
    },
    aboutInfo(){
      return this.$store.getters.homeData.aboutInfo
    }
  },
  created() {
    this.$store.dispatch('setPageCurrentIndex',1)
  }
}
</script>
<style scoped lang="scss">
.page2{
  background-image: url("../../assets/image/page2_bg.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  height: 100vh;
  .page2Warp{
    height: 100%;
    width: calc(70% + 6rem);
    box-sizing: border-box;
    padding: 2rem 3rem;
    margin: auto;
    //overflow-y: scroll;
    //overflow-x: visible;
    /* 隐藏滚动条 */
    overflow: auto;
    -ms-overflow-style: none; /* IE 和 Edge */
    scrollbar-width: none; /* Firefox */
    .twoPageWarp{
      width: 100%;
      height: 100%;
      .artList{
        overflow: hidden;
        margin-left: -4rem;
        margin-top: 1rem;
        flex: 1;
        display: flex;
        align-items: stretch;
        flex-wrap: wrap;
        .artItem{
          width: calc(50% - 4rem);
          margin-left: 4rem;
          //float: left;
          //height: 12vh;
          color: #fff;
          font-size: .9rem;
          background: linear-gradient(146deg, #3578C1 0%, rgba(43,106,185,0) 80%);
          border-radius: 100rem;
          margin-top: 1.2rem;
          padding: 1.2rem 1.8rem 1.2rem 3.5rem;
          box-sizing: border-box;
          position: relative;
          min-height: 6rem;
          .artItemImage{
            width: 5rem;
            position: absolute;
            left: -2.2rem;
            top: 0;
            z-index: 10;
          }
          .artItemText{
            height: 100%;
            //overflow-y: hidden;
            word-break: keep-all;
            hyphens:none;
          }
        }
      }
      .page2TitleWarp{
        width: calc(100% + 2rem);
        margin-left: -2rem;
        color: #fff;
        .title{
          font-size: 2.2rem;
        }
        .desc{
          font-size: 1rem;
          margin-top: 1.5rem;
          line-height: 1.6rem;
          word-break: break-word;
        }
      }
    }
  }
}
</style>
